import axios from "axios";
import Store from "./Store";
import {
  popupMessagesHandler,
  setLoading,
  set_Load_Download,
  set_Message,
  set_Qr_Loading,
} from "./Orders/OrderActionCreators";
import {
  authUnauthorizedMessage,
  officeAuth,
  setShowCaptcha,
} from "./Login/LoginActionCreators";
// import { closeSocket } from "./Socket/socket";
require("dotenv").config();

const BaseUrl =
  // process.env.NODE_ENV === "development"
  // ?
  process.env.REACT_APP_BASE_URL_DEV;
// : process.env.REACT_APP_BASE_URL_PRO;

export const axiosInstance = axios.create({
  baseURL: BaseUrl,
});
// window.onbeforeunload = () => {
//   socket.disconnect();
// };
axiosInstance.interceptors.request.use((config) => {
  if (!navigator.onLine) {
    const chanel = new BroadcastChannel("isOnline");
    chanel.postMessage({ msg: "notOnline" });
  }
  config.url += `?timeStamp=${new Date().getTime()}`;
  config.headers["token"] = localStorage.token;
  Store.dispatch(setLoading(true));

  return config;
});

axiosInstance.interceptors.response.use(
  (config) => {
    Store.dispatch(setLoading(false));
    return config;
  },

  (error) => {
    Store.dispatch(setLoading(false));
    Store.dispatch(set_Qr_Loading(false));
    switch (error.response.status) {
      case 401:
        Store.dispatch(authUnauthorizedMessage(error.response.data));
        Store.dispatch(
          popupMessagesHandler({
            mode: true,
            message: error.response.data,
            color: "error",
          })
        );
        // closeSocket();
        setTimeout(() => {
          localStorage.clear();
          window.location.pathname = "/";
          Store.dispatch(officeAuth(false));
        }, 2000);
        break;

      case 400:
        if (error.response.data.type !== "application/json") {
          Store.dispatch(
            set_Load_Download({
              all: false,
              single: false,
            })
          );
          Store.dispatch(set_Message(error.response.data));
          Store.dispatch(authUnauthorizedMessage(error.response.data));
          Store.dispatch(
            popupMessagesHandler({
              mode: true,
              message: error.response.data,
              color: "info",
            })
          );
        } else {
          Store.dispatch(
            set_Load_Download({
              all: false,
              single: false,
            })
          );
          Store.dispatch(
            popupMessagesHandler({
              mode: true,
              message: "فایل یافت نشد",
              color: "info",
            })
          );
        }
        break;
      case 402:
        Store.dispatch(authUnauthorizedMessage(error.response.data));
        Store.dispatch(setShowCaptcha(true));
        Store.dispatch(
          popupMessagesHandler({
            mode: true,
            message: error.response.data,
            color: "info",
          })
        );

        break;
      case 403:
        Store.dispatch(authUnauthorizedMessage(error.response.data));

        Store.dispatch(
          popupMessagesHandler({
            mode: true,
            message: error.response.data,
            color: "info",
          })
        );
        break;
      case 404:
        Store.dispatch(authUnauthorizedMessage(error.response.data));
        Store.dispatch(
          popupMessagesHandler({
            mode: true,
            message:
              typeof error.response.data === "object"
                ? error.response.statusText
                : error.response.data,
            color: "info",
          })
        );
        Store.dispatch(
          set_Load_Download({
            all: false,
            single: false,
          })
        );
        break;

      default:
        break;
    }

    return Promise.reject(error);
  }
);
